import Fetch from 'jsx/common/util/_fetch';

export const all = async (groupId?: number) => {
  return Fetch.get(`/api/user/${groupId ? `?groups=${groupId}` : ''}`);
};

export const single = async (userId: string) => {
  return Fetch.get(`/api/user/${userId}/`);
};
